/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
    baseClasses,
    iconComponent,
    iconSizeStyles,
    loadingStyles,
    variantStyles,
} from 'src/domains/common/components/button/button-utils';
import { IconButtonPropsType } from 'src/domains/common/components/button/button.types';
import { cn } from 'src/domains/common/components/utils';
import { observer } from 'src/utils/mobx-react';

export const IconButton = observer(
    'IconButton',
    ({
        className,
        dataTest,
        icon,
        isLoading = false,
        size = 'default',
        variant = 'primary',
        type = 'button',
        ...props
    }: IconButtonPropsType) => {
        const iconClass = cn('size-4', {
            'animate-spin text-foreground': isLoading,
        });

        return (
            <button
                className={cn(
                    baseClasses,
                    variantStyles(variant),
                    iconSizeStyles(size),
                    loadingStyles(isLoading),
                    className,
                    'disabled:cursor-not-allowed'
                )}
                data-test={dataTest}
                type={type}
                {...props}
            >
                {iconComponent(isLoading, icon, iconClass)}
            </button>
        );
    }
);
